import React from 'react';
import './Emblem.css';

interface EmblemProps {
  completedTasks: number;
  totalTasks: number;
  householdName?: string;
}

export const Emblem: React.FC<EmblemProps> = ({ completedTasks, totalTasks, householdName }) => {
  const progress = totalTasks > 0 ? completedTasks / totalTasks : 0;
  const radius = 38;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - progress);

  return (
    <div className="emblem">
      <div className="emblem-visual">
        <svg className="emblem-wreath" viewBox="0 0 100 105" width="130" height="136" aria-hidden="true">
          <path d="M46 92 C26 78, 16 52, 24 24" fill="none" stroke="#7AAE76" strokeWidth="1.2" strokeLinecap="round" />
          <path d="M54 92 C74 78, 84 52, 76 24" fill="none" stroke="#7AAE76" strokeWidth="1.2" strokeLinecap="round" />
          <ellipse cx="36" cy="82" rx="9" ry="4" fill="#8BC487" opacity="0.9" transform="rotate(-18 36 82)" />
          <ellipse cx="26" cy="67" rx="9" ry="4" fill="#A3D89B" opacity="0.85" transform="rotate(-33 26 67)" />
          <ellipse cx="20" cy="52" rx="9" ry="4" fill="#8BC487" opacity="0.9" transform="rotate(-48 20 52)" />
          <ellipse cx="20" cy="38" rx="8" ry="3.5" fill="#A3D89B" opacity="0.85" transform="rotate(-60 20 38)" />
          <ellipse cx="24" cy="26" rx="7" ry="3" fill="#8BC487" opacity="0.9" transform="rotate(-72 24 26)" />
          <ellipse cx="33" cy="74" rx="6" ry="2.5" fill="#6FA06A" opacity="0.45" transform="rotate(-25 33 74)" />
          <ellipse cx="25" cy="56" rx="6" ry="2.5" fill="#6FA06A" opacity="0.45" transform="rotate(-44 25 56)" />
          <ellipse cx="24" cy="42" rx="5" ry="2" fill="#6FA06A" opacity="0.4" transform="rotate(-55 24 42)" />
          <ellipse cx="64" cy="82" rx="9" ry="4" fill="#8BC487" opacity="0.9" transform="rotate(18 64 82)" />
          <ellipse cx="74" cy="67" rx="9" ry="4" fill="#A3D89B" opacity="0.85" transform="rotate(33 74 67)" />
          <ellipse cx="80" cy="52" rx="9" ry="4" fill="#8BC487" opacity="0.9" transform="rotate(48 80 52)" />
          <ellipse cx="80" cy="38" rx="8" ry="3.5" fill="#A3D89B" opacity="0.85" transform="rotate(60 80 38)" />
          <ellipse cx="76" cy="26" rx="7" ry="3" fill="#8BC487" opacity="0.9" transform="rotate(72 76 26)" />
          <ellipse cx="67" cy="74" rx="6" ry="2.5" fill="#6FA06A" opacity="0.45" transform="rotate(25 67 74)" />
          <ellipse cx="75" cy="56" rx="6" ry="2.5" fill="#6FA06A" opacity="0.45" transform="rotate(44 75 56)" />
          <ellipse cx="76" cy="42" rx="5" ry="2" fill="#6FA06A" opacity="0.4" transform="rotate(55 76 42)" />
        </svg>
        <svg className="emblem-ring" viewBox="0 0 100 100" width="72" height="72">
          <circle cx="50" cy="50" r={radius} fill="none" stroke="#EDEDED" strokeWidth="3" />
          <circle
            cx="50" cy="50" r={radius}
            fill="none" stroke="#B9A3E6" strokeWidth="3.5" strokeLinecap="round"
            strokeDasharray={circumference} strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 50 50)" className="emblem-ring-progress"
          />
        </svg>
        <span className="emblem-heart" role="img" aria-label="heart">💜</span>
      </div>
      <div className="emblem-divider" />
      <p className="emblem-tagline">
        {householdName ? (
          <><span className="emblem-household">{householdName}</span> — </>
        ) : null}
        A clean home is a happy home <span className="emblem-tagline-heart">💕</span>
      </p>
    </div>
  );
};
